import React from 'react';
import Logo from '@/components/molecules/header/Logo';
import styles from './Header.module.scss';

const UnaccessibleHeader: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <Logo />
      </div>
    </div>
  );
};

export default UnaccessibleHeader;
